export const messages = {
  page: {
    title: {
      id: 'questionnaires.Title',
      defaultMessage: 'Questionnaires',
    },
    zeroState: {
      id: 'questionnaires.Page.ZeroState',
      defaultMessage: 'No items to display',
    },
  },
  button: {
    current: {
      id: 'questionnaires.Button.Current',
      defaultMessage: 'Current',
    },
    history: {
      id: 'questionnaires.Button.History',
      defaultMessage: 'History',
    },
    startNow: {
      id: 'questionnaires.Button.StartNow',
      defaultMessage: 'Start Now',
    },
    decline: {
      id: 'questionnaires.Button.Decline',
      defaultMessage: 'Decline',
    },
    submit: {
      id: 'questionnaires.Button.Submit',
      defaultMessage: 'Submit Questionnaire',
    },
    cancel: {
      id: 'questionnaires.Button.Cancel',
      defaultMessage: 'Cancel',
    },
    review: {
      id: 'questionnaires.Button.Review',
      defaultMessage: 'Review',
    },
  },
  date: {
    due: {
      id: 'questionnaires.Date.Due',
      defaultMessage: 'Due: ',
    },
    overdue: {
      id: 'questionnaires.Date.Overdue',
      defaultMessage: 'Overdue: ',
    },
    completed: {
      id: 'questionnaires.Date.Completed',
      defaultMessage: 'Completed: ',
    },
    declined: {
      id: 'questionnaires.Date.Declined',
      defaultMessage: 'Declined: ',
    },
    missed: {
      id: 'questionnaires.Date.Missed',
      defaultMessage: 'Missed: ',
    },
  },
  declineModal: {
    title: {
      id: 'questionnaires.DeclineModal.Title',
      defaultMessage: 'Are you sure?',
    },
    message: {
      id: 'questionnaires.DeclineModal.Message',
      defaultMessage: 'This questionnaire will no longer be available to complete.',
    },
    submitBtnText: {
      id: 'questionnaires.DeclineModal.SubmitBtnText',
      defaultMessage: 'Yes, I want to decline',
    },
    hideBtnText: {
      id: 'questionnaires.DeclineModal.HideBtnText',
      defaultMessage: 'No, take me back',
    },
  },
  scoring: {
    backButtonText: {
      id: 'questionnaires.Scoring.BackBtnText',
      defaultMessage: 'Back to Questionnaires',
    },
    exitButtonText: {
      id: 'questionnaires.Scoring.ExitBtnText',
      defaultMessage: 'Finish and exit',
    },
  },
  asterisk: {
    name: {
      id: 'questionnaire.Asterisk.Name',
      defaultMessage: 'An asterisk ',
    },
    description: {
      id: 'questionnaire.Asterisk.Description',
      defaultMessage: ' denotes required questions.',
    },
  },
  labels: {
    dateDropdown: {
      id: 'questionnaires.DateQuestion.Labels.DateDropDown',
      defaultMessage: 'Click to select a date',
    },
  },
};
